export default __webpack_public_path__ + "static/media/ArrowGray.fe431018.svg";